import { DataSourceStore } from '@bingads-webui-campaign/data-source-store';
import { connect } from '@bingads-webui-campaign/dqb-grid-datasource-connector';
import { QueryBuilderFactory } from '@bingads-webui-campaign/query-builder';
/* eslint-disable */
import * as instrumentation from '@bingads-webui-campaign-legacy/instrumentation/index';
import logger from '@bingads-webui-static-legacy/instrumentation/index';
import _ from 'underscore';
/* eslint-enable */

export function fetchDataForPerformance(serverContext, resolve, preferenceService) {
  import(/* webpackMode: 'eager' */'@bingads-webui-campaign-legacy/accounts-summary/data-fetch-config').then((dataFetchConfig) => {
    instrumentation.default.addScenario({
      scenario: [
        {
          name: 'accountsSummaryDataPrefetch',
          value: 'AccountsSummaryDataPrefetch',
          activity: [
            {
              name: 'dataQueryBuilder',
              value: 'DataQueryBuilder',
            },
          ],
        },
      ],
    });

    const logActivity = instrumentation
      .default
      .accountsSummaryDataPrefetch
      .create()
      .dataQueryBuilder
      .create();

    const currentHash = (window.location.hash || '').toLowerCase();
    const isLandingPage = currentHash.length === 0 || currentHash.indexOf('/campaign/vnext/accounts/performance') > 0;

    // If not landing page, resolve right away
    if (!isLandingPage) {
      resolve();
    }

    const config = dataFetchConfig.getConfig(preferenceService);
    const queryBuilderConfig = _.extend(config.queryBuilder, { logActivity });
    if (serverContext.CurrentCustomer.HasUnifiedSmartAccount) {
      queryBuilderConfig.commonConfig.featureName = 'SmartPerformanceGrid';
    }
    const { featureName } = queryBuilderConfig.commonConfig;
    const queryBuilder = QueryBuilderFactory.make(queryBuilderConfig);
    // Default page size has changed to 50 in new UI performance page, was 20 in old UI accounts summary page
    queryBuilder.getDecoratorByName('pagination').defaultPageSize = 50;
    // For Unified Product Phase 2, default grid type based on presence of UnifiedSmart accounts belonging to current customer
    if (serverContext.CurrentCustomer.HasUnifiedSmartAccount) {
      queryBuilder.getDecoratorByName('gridDataParameters').accountModes = ['Smart'];
    } else {
      queryBuilder.getDecoratorByName('gridDataParameters').accountModes = ['Expert'];
    }
     // Get right filter value from preferences
     const { filterService } = queryBuilder.getDecoratorByName('filter');

     let editableFilter = preferenceService.findByName(`editable-filter-storage-campaignwebui-${queryBuilderConfig.commonConfig.featureName}-undefined/EditableFilter`);
     editableFilter = editableFilter && editableFilter.Data ? editableFilter.Data : null;

     filterService.editableFilterStorage.save(editableFilter);

    const dataSource = connect(
      config.dataSource,
      queryBuilder,
      featureName,
      logger
    );

    // log to figure out defaultcolumns warmup cache error
    const { IsAvgPositionDeprecationPhase2Enabled, defaultColumns } = queryBuilder.getDecoratorByName('columnChooser');
    logger.logMessage([logger.constants.LOGCATEGORY.TRACE], logger.constants.LOGLEVEL.INFO, '/accounts/performance', `Default columns used in warmup query in fetch-performance-page.js: ${defaultColumns}, IsAvgPositionDeprecationPhase2Enabled: ${IsAvgPositionDeprecationPhase2Enabled}`);

    const { AccountSummaryFilterImprovementEnabled } = serverContext.DynamicPermissions;

    dataSource.query({}, {}, resolve);

    if (!AccountSummaryFilterImprovementEnabled) {
      DataSourceStore.set(featureName, dataSource);
    } else {
      const cacheableObjects = {
        dataSource,
        filterService: config.filterService,
      };

      DataSourceStore.set(featureName, cacheableObjects);
    }
  });
}
